module.exports = __webpack_public_path__ + "static/img/period.2ee302d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/period.png
// module id = VR/A
// module chunks = 9